import { getLandingUrlFromPath } from '@doltech/utils/lib/url';
import cl from 'classnames';
import * as React from 'react';
import { FacebookShareButton } from 'react-share';

interface DolFacebookShareButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  external?: boolean;
  url: string;
  pageId?: string;
  children: JSX.Element | React.ReactNode | React.ReactNode[];
  className?: string;
}

export const DolFacebookShareButton = ({
  url,
  children,
  external = false,
  className,
  pageId,
  ...rest
}: DolFacebookShareButtonProps) => {
  return (
    <FacebookShareButton
      className={cl('btn-facebook-share', className)}
      url={external ? url : getLandingUrlFromPath(url)}
      {...rest}
    >
      {children}
    </FacebookShareButton>
  );
};
